import { Col, Row } from "antd";
import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import colors from "core/resources/theme/colors";
import calendarBlank from "assets/images/svgs/calendar-blank.svg";
import calendarToday from "assets/images/svgs/calendar-today.svg";
import calendarClock from "assets/images/svgs/calendar-clock-orange.svg";
import { Image } from "@chakra-ui/react";
import { ReservaFiltroAdv } from "core/features/reservas/typings";
import moment from "moment";
import { isEqual } from "lodash";
import { StatusReservaEnum } from "core/features/reservas/typings";

interface DashboardReservasProps {
  reservasHoje?: number;
  totalReservas?: number;
  semAprovacao?: number;
  loading?: boolean;
  filtro?: Partial<ReservaFiltroAdv>;
  onResetFiltro?: (newValues: Partial<ReservaFiltroAdv>) => void;
}

const stateFiltroTotalReservas: Partial<ReservaFiltroAdv> = {
  dataInicio: undefined,
  dataFim: undefined,
};

const stateReservasHoje: Partial<ReservaFiltroAdv> = {
  dataInicio: moment().format("YYYY-MM-DD"),
  dataFim: moment().format("YYYY-MM-DD"),
};

const stateReservasPendentes: Partial<ReservaFiltroAdv> = {
  dataInicio: undefined,
  dataFim: undefined,
  status: StatusReservaEnum.Pendente,
};

function DashboardReservas({
  reservasHoje = 0,
  totalReservas = 0,
  semAprovacao = 0,
  loading,
  filtro,
  onResetFiltro,
}: DashboardReservasProps) {
  const checkStateFiltroCardTotalReservas = () => {
    return isEqual(filtro, {
      ...stateFiltroTotalReservas,
      page: filtro?.page,
      limit: filtro?.limit,
    });
  };

  const checkStateFiltroCardReservasHoje = () => {
    return isEqual(filtro, {
      ...stateReservasHoje,
      page: filtro?.page,
      limit: filtro?.limit,
    });
  };

  const checkStateFiltroCardReservasPendentes = () => {
    return isEqual(filtro, {
      ...stateReservasPendentes,
      page: filtro?.page,
      limit: filtro?.limit,
    });
  };

  return (
    <>
      <Row gutter={16}>
        <Col sm={6}>
          <Card1Horizontal
            icon={<Image src={calendarBlank} w="100%" h="25px" />}
            color={colors.pink}
            bg={colors.pink500}
            selected={checkStateFiltroCardTotalReservas()}
            description="Total de reservas"
            onClick={() => {
              onResetFiltro?.({
                dataInicio: undefined,
                dataFim: undefined,
              });
            }}
            title={`${totalReservas}`}
            loading={loading}
          />
        </Col>
        <Col sm={6}>
          <Card1Horizontal
            icon={<Image src={calendarToday} w="100%" h="25px" />}
            color={colors.green}
            bg={colors.green100}
            description="Reservas hoje"
            selected={checkStateFiltroCardReservasHoje()}
            onClick={() => {
              onResetFiltro?.({
                dataInicio: moment().format("YYYY-MM-DD"),
                dataFim: moment().format("YYYY-MM-DD"),
              });
            }}
            title={`${reservasHoje}`}
            loading={loading}
          />
        </Col>
        <Col sm={6}>
          <Card1Horizontal
            icon={<Image src={calendarClock} w="100%" h="25px" />}
            color={colors.red}
            bg={colors.orange50}
            description="Pendentes de aprovação"
            selected={checkStateFiltroCardReservasPendentes()}
            onClick={() => {
              onResetFiltro?.({
                dataInicio: undefined,
                dataFim: undefined,
                status: StatusReservaEnum.Pendente,
              });
            }}
            title={`${semAprovacao}`}
            loading={loading}
          />
        </Col>
      </Row>
    </>
  );
}

export default DashboardReservas;
